import React, { useEffect, useRef, useState } from 'react';
import './BrowserTop.css';

import { useNavigate, useLocation } from 'react-router-dom';
import DatePicker from 'react-datepicker';

import { format } from 'date-fns';

import 'react-datepicker/dist/react-datepicker.css';
import { ReactComponent as CopyLinkSVG } from '../Images/buttons/linkCopyGray.svg';
import { ReactComponent as CloseSVG } from '../Images/buttons/closeBlackButton.svg';
import { ReactComponent as BackArrowSVG } from '../Images/buttons/backArrow.svg';
import { ReactComponent as HatenaSVG } from '../Images/buttons/hatenaButton.svg';
import { ReactComponent as EditSVG } from '../Images/buttons/editButton.svg';
import { ReactComponent as TokenLockSVG } from '../Images/buttons/tokenLockButton.svg';
import { ReactComponent as LogoSVG } from '../Images/header/logoBlack.svg';
import { ReactComponent as SettingSVG } from '../Images/header/settingBlack.svg';
import AddAccess from '../Util/AddAccess';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { isAuthAtom, isAuthLoadedAtom, pageAtom, topMessageAtom } from '../../State';
import DataModel from '../Util/DataModel';
import FaceImage from '../Setting/FaceImage';
import { useTranslation } from 'react-i18next';
import Loading from '../Loading/Loading';
import isElectron from '../../Global';

export default function ShowLive({ roomID, setShowLiveState }) {
  //Recoil系
  const [authState, setAuthState] = useRecoilState(isAuthAtom);
  const setTopMessageState = useSetRecoilState(topMessageAtom);
  const { t, i18n } = useTranslation();

  //その他
  const [startDetailDate, setStartDetailDate] = useState(null);
  const [titleState, setTitleState] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [gatedData, setGatedData] = useState(null);
  const [titleDetailState, setTitleDetailState] = useState(null);
  const [imageURLState, setImageURLState] = useState(null);
  const [hatenaState, setHatenaState] = useState(false);
  const [hatenaState2, setHatenaState2] = useState(false);
  const [meetingIDState, setMeetingIDState] = useState(null);
  const [meetingTokenState, setMeetingTokenState] = useState(null);
  const [loadingState, setLoadingState] = useState(false);
  const [isTokenGated, setIsTokenGated] = useState(false);
  const navigate = useNavigate(); //リダイレクト用
  const [isLoadingState, setIsLoadingState] = useState(true);
  const liveRoomID = useRef(null);

  useEffect(() => {
    getRoomInfo();
  }, []);

  const getRoomInfo = async (event) => {
    //ローディング中
    setIsLoadingState(true);

    //ルーム情報取得
    const roomInfo = await DataModel.checkRoom(roomID, true, null);

    //ルームが存在しない場合
    if (roomInfo.dailyRoomURL == null) {
      alert(t('mypage.URL is not valid. No room exist'));
      //強制的にトップページヘ
      if (authState) {
        navigate('/app');
      }
    }
    //ルームが存在する場合
    else {
      //ローディング完了
      setIsLoadingState(false);

      setMeetingIDState(roomID);

      //ミーティングトークン
      setMeetingTokenState(roomInfo.meetingToken);

      //タイトル
      setTitleState(roomInfo.liveData?.liveTitle);
      setTitleDetailState(roomInfo.liveData?.liveTitle);

      //画像
      setImageURLState(roomInfo.liveData?.liveImageURL ?? 'facelessboy');

      //開始時間
      let date = new Date(roomInfo.liveData?.liveDate?._seconds * 1000);
      let formatDate;
      if (i18n.language == 'ja') {
        formatDate = format(
          date,
          'MM' + '月' + 'dd' + '日 ' + 'h' + '時' + 'mm' + '分 ' + 'a' + ' スタート',
        );
      } else {
        formatDate = format(date, 'MMM do hh:mm a');
      }

      setStartDetailDate(formatDate);
      setStartDate(date);

      if (roomInfo.liveData?.isTokenGated) {
        setIsTokenGated(true);
      }

      //トークンゲート情報
      var tokenGatedObject = {};
      if (roomInfo.liveData?.tokenGatedType) {
        tokenGatedObject.tokenGatedType = roomInfo.liveData?.tokenGatedType;
      }
      if (roomInfo.liveData?.contractAddress) {
        tokenGatedObject.contractAddress = roomInfo.liveData?.contractAddress;
      }
      if (roomInfo.liveData?.ercType) {
        tokenGatedObject.ercType = roomInfo.liveData?.ercType;
      }
      if (roomInfo.liveData?.chain) {
        tokenGatedObject.chain = roomInfo.liveData?.chain;
      }
      if (roomInfo.liveData?.collectionID) {
        tokenGatedObject.collectionID = roomInfo.liveData?.collectionID;
      }
      if (roomInfo.liveData?.collectionName) {
        tokenGatedObject.collectionName = roomInfo.liveData?.collectionName;
      }
      if (roomInfo.liveData?.collectionImageURL) {
        tokenGatedObject.collectionImageURL = roomInfo.liveData?.collectionImageURL;
      }

      if (roomInfo.liveData?.slugName) {
        tokenGatedObject.slugName = roomInfo.liveData?.slugName;
      }

      if (tokenGatedObject != {}) {
        setGatedData(tokenGatedObject);
      }
    }
  };

  const hatenaOver = async () => {
    setHatenaState(true);
  };

  const hatenaOut = async () => {
    setHatenaState(false);
  };

  const hatenaOver2 = async () => {
    setHatenaState2(true);
  };

  const hatenaOut2 = async () => {
    setHatenaState2(false);
  };

  //クリップボードにコピー
  const copyURL = (status) => {
    var url = 'https://faceless.ooo/l/' + meetingIDState;
    if (status == 'speaker') {
      url += '/' + meetingTokenState;
    }
    navigator.clipboard.writeText(url).then(
      function () {
        setTopMessageState({ type: 'copied', message: t('top.Copied Successfully') });
        AddAccess('click', 'copiedURL');
      },
      function (err) {},
    );
  };

  const clickStart = async () => {
    if (isElectron) {
      const url = await window.myapi.getURL('l/' + meetingIDState + '/' + meetingTokenState);
      window.open(url, '_blank');
    } else {
      navigate('/l/' + meetingIDState + '/' + meetingTokenState);
    }
  };

  const clickEdit = async () => {
    setShowLiveState('edit');
  };

  return (
    <>
      <div id="liveCheckWrap">
        <div className="electronTop">
          {/*ローディング中*/}
          <div className="isElectron">
            <Loading loadingState={isLoadingState} />
          </div>
          <div className="electronInputHeader">
            <div className="electronTitle"></div>
            <div className="electronHeaderSetting electronHeaderEdit" onClick={() => clickEdit()}>
              <EditSVG />
            </div>
            <div className="electronHeaderSetting" onClick={() => setShowLiveState(null)}>
              <CloseSVG />
            </div>
          </div>

          <div id="liveTitle">
            {titleDetailState ?? t('mypage.No title')} {isTokenGated && <TokenLockSVG />}
          </div>
          <div id="liveDate">{startDetailDate ?? t('mypage.Start date is not specified')}</div>
          <div id="liveImage">
            <FaceImage myNftState={imageURLState} />
          </div>

          <div className="electronInputWrap">
            <div className="electronLiveWrap">
              {hatenaState && (
                <div className="electronLiveDetal">{t('mypage.Share this url for viewer...')}</div>
              )}
              <div className="electronLiveText">{t('mypage.Viewer URL')}</div>
              <div className="electronHatena" onMouseEnter={hatenaOver} onMouseLeave={hatenaOut}>
                <HatenaSVG />
              </div>
            </div>
            <div className="electronURLWrap" onClick={copyURL}>
              <div className="urlInside">
                {meetingIDState == null ? '--- --- --- ' : 'faceless.ooo/l/' + meetingIDState}
              </div>
              <div className="IDCopy">
                <CopyLinkSVG />
              </div>
            </div>
          </div>

          <div className="electronInputWrap">
            <div className="electronLiveWrap">
              {hatenaState2 && (
                <div className="electronLiveDetal">{t('mypage.Share this url for speaker...')}</div>
              )}
              <div className="electronLiveText">{t('mypage.Speaker URL')}</div>
              <div className="electronHatena" onMouseEnter={hatenaOver2} onMouseLeave={hatenaOut2}>
                <HatenaSVG />
              </div>
            </div>
            <div className="electronURLWrap" onClick={() => copyURL('speaker')}>
              <div className="urlInside">
                {meetingIDState == null
                  ? '--- --- --- '
                  : 'faceless.ooo/l/' + meetingIDState + '/' + meetingTokenState ?? ''}
              </div>
              <div className="IDCopy">
                <CopyLinkSVG />
              </div>
            </div>
          </div>

          <div className="electronInputButtonWrap">
            <button id="newMeetingButton" className="topIDITem" onClick={clickStart}>
              <div id="newMeetingLeft">{/* <JoinLeftSVG /> */}</div>
              <div className="topIDName">{t('mypage.Start as a speaker')}</div>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
